import React from 'react'
import './Post.css'
import { useNavigate } from 'react-router-dom'

function Post(props) {
  
    const navigate = useNavigate()
    let locText = ""
    const date = new Date(props.data.date)
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    if (props.data.location) {
        const st = props.data.location.split(',')
        let st1 = []
        if (st.length > 3) {
            st1 = st.slice(Math.max(st.length - 3, 1))
        } else {
            st1 = st.slice(Math.max(st.length - 3, 1))
        }
        locText = st1.join(",")
    }

    return (
        <div className='row post-container' style={{ color: 'white' }}
            onClick={() => navigate(`/event?u=${props.data.author}--i=${props.data.id}`)}
        >
            <div className='img-container-post'>
                <div>
                    {props.data.eventBanner ? 
                    <img style={{ width: '35vw', height: 100, objectFit: 'cover', borderRadius: 10 }} src={props.data.eventBanner} />:
                    <img style={{ width: '35vw', height: 100, objectFit: 'cover', borderRadius: 10 }} src={process.env.PUBLIC_URL + '/icon.jpg'} />
                    }
                    
                </div>                
                <div className='col center'>
                    <p style={{ color: 'white', fontSize: 14, fontWeight: 500, paddingBottom: 0, lineHeight: '12px' }}>{props.data.title}</p>
                    <p className='magenta' style={{ fontSize: 10, fontWeight: 700, paddingBottom: 2, paddingTop: 2 }}>{props.data.authorName}</p>
                    <p style={{ fontSize: 10, fontWeight: 700, paddingBottom: 0, width: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{locText}</p>
                </div>
            </div>
            

            <div className='col center'>
                <div style={{justifyContent:'center', marginRight:10}}>
                    <div style={{
                        border: '1px solid #0a0a0a',
                        backgroundImage: 'linear-gradient(to top right, #161B41 0%, #8E0B59 100%)',                         
                        padding: '2px 10px',
                        borderTopLeftRadius:10, 
                        textAlign:'center',
                        borderTopRightRadius:10
                    }}>
                        <p lightColor="white" style={{ fontSize: 10 }}>
                            {months[date.getMonth()]}
                        </p>
                    </div>
                    <div style={{ 
                        border: '1px solid #0a0a0a', 
                        borderBottomLeftRadius: 10, 
                        textAlign:'center',                        
                        // paddingBottom:'0 !important',
                        padding: '2px 10px',
                        backgroundColor: '#0a0a0a',
                        borderBottomRightRadius: 10 }}>
                        <p style={{ fontSize: 10 }}>{date.getDate()}</p>
                    </div>
                </div>
            </div>

            {/* {props.id} */}
        </div>
    )
}

export default Post 